<template>
  <div>
    <!-- Title -->
    <v-container>
      <v-card class="mx-auto">
        <template v-if="this.catCode != null">
          <v-card-title>
            CatCode Details
          </v-card-title>

          <v-btn color="primary" class="ma-3" v-on:click="scanCatCode">
            <v-icon left>mdi-search-web</v-icon>
            Scan Now
          </v-btn>

          <v-form>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field label="CatCode" v-model="catCode.catCodeString" />
                  <v-select label="Part Group" v-model="catCode.partGroupID" :items="partGroups" item-text="name"
                    item-value="id" />
                  <v-text-field label="Description" v-model="catCode.catCodeDesc" />
                  <v-text-field label="Words to include" v-model="catCode.wordsToInclude" />
                  <v-text-field label="Words to exclude" v-model="catCode.wordsToExclude" />
                  <v-text-field label="Days between scans (Default)" v-model="catCode.daysBetweenScans" />
                  <v-text-field v-for="marketplace in this.marketplaces"
                    :key="marketplace.id"
                    :label="`Days between scans (${marketplace.name}) (default: ${catCode.daysBetweenScans * marketplace.daysBetweenScansMultiplier})`"
                    v-model="marketplace.daysBetweenScans" />
                  <v-text-field label="Refined min qty" v-model="catCode.refinedMinQty" />
                  <v-text-field label="Quantity cap" v-model="catCode.qtyCap" />
                  <v-text-field label="Min qty to scan" v-model="catCode.minQtyToScan" />
                </v-col>
                <v-col cols="6">
                  <div class="subtitle-1">Effective search terms</div>
                  <div v-if="keywords == null" class="text--secondary">Loading...</div>
                  <template v-else>
                    <v-simple-table dense>
                      <thead>
                        <tr>
                          <th>Source</th>
                          <th>Include</th>
                          <th>Exclude</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>This CatCode</td>
                          <td>{{ keywords.catCodeWordsToInclude }}</td>
                          <td>{{ keywords.catCodeWordsToExclude }}</td>
                        </tr>
                        <tr v-for="level in keywords.levels" :key="level.categoryID">
                          <td>{{ level.description }}</td>
                          <td>{{ level.wordsToInclude }}</td>
                          <td>{{ level.wordsToExclude }}</td>
                        </tr>
                        <tr>
                          <td>Part Group: {{ keywords.partGroupName }}</td>
                          <td>{{ keywords.partGroupWordsToInclude }}</td>
                          <td>{{ keywords.partGroupWordsToExclude }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                    <div class="mt-2 caption">
                      Category terms are managed on the
                      <router-link :to="{ name: 'Category Keywords' }">Category Keywords</router-link> page.
                    </div>
                    <div class="mt-4 subtitle-2">eBay search preview ({{ (keywords.keywordsPreview || '').length }} characters)</div>
                    <code class="keywords-preview">{{ keywords.keywordsPreview }}</code>
                  </template>
                </v-col>
              </v-row>
            </v-container>
          </v-form>

          <v-row>
            <v-col cols="5">
              <v-btn color="primary" class="ma-3" v-on:click="saveCatCode">
                <v-icon left>mdi-content-save</v-icon>
                Save
              </v-btn>
              <v-btn color="warning" class="ma-3" v-on:click="navigateBackToCatCodes">
                <v-icon left>mdi-arrow-left</v-icon>
                Back
              </v-btn>
            </v-col>
            <v-col cols="1">
              <v-btn color="error" class="ma-3" v-on:click="deleteCatCode">
                <v-icon left>mdi-delete</v-icon>
                Delete
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <p class="display-1 text--primary">
            Loading...
          </p>
        </template>
      </v-card>
    </v-container>
    <!-- /Title -->

  </div>
</template>

<script>
// API wrapper
import { CatCodesService } from '../services/api/catCodes';
import { SnapshotsService } from '../services/api/snapshots';
import { PartGroupsService } from '../services/api/partGroups';
import { MarketplacesService } from '../services/api/marketplaces';
import { CategoryKeywordsService } from '../services/api/categoryKeywords';
const apiCatCodes = new CatCodesService();
const apiSnapshots = new SnapshotsService();
const apiPartGroups = new PartGroupsService();
const apiMarketplace = new MarketplacesService();
const apiCategoryKeywords = new CategoryKeywordsService();


export default {
  data() {
    return {
      catCode: null,
      keywords: null,
      partGroups: [],
      marketplaces: [],
      loading: true,
    }
  },

  async mounted() {
    this.loading = true;
    await this.getCatCode();
    this.getKeywords();
    await this.getPartGroups();
    await this.getMarketplaces();
    console.log('partGroups', this.partGroups);
    this.loading = false;
  },
  methods: {

    scanCatCode() {
      // Start a scan on the current CatCode.
      alert('scanning cat code: ' + this.catCode.catCodeString);

      apiSnapshots.startScan(this.catCode.catCodeString);
    },

    async getCatCode() {
      if (this.$route.params.catCodeString) {
        this.catCode = await apiCatCodes.getCatCodeByString(this.$route.params.catCodeString);
      } else if (this.$route.params.id) {
        this.catCode = await apiCatCodes.getCatCode(this.$route.params.id);
      } else {
        // show error toast, delay, then redirect
        this.$notify({
          title: 'CatCode not found!',
          type: 'error'
        });
        setTimeout(() => {
          this.$router.replace({ name: "CatCodes" }); // redirect to CatCodes page
        }, 3000);
        return; // stop further execution
      }
    },

    async getKeywords() {
      this.keywords = await apiCategoryKeywords.getForCatCode(this.catCode.catCodeString);
    },

    async getPartGroups() {
      this.partGroups = (await apiPartGroups.getPartGroups()).items;
    },

    async getMarketplaces() {
      this.marketplaces = await apiMarketplace.getMarketplaces();
      this.setMarketplaceSettings();
    },

    setMarketplaceSettings() {
      for (let i = 0; i < this.marketplaces.length; i++) {
        this.catCode.marketplaceSettings?.forEach((marketplaceSetting) => {
          if (marketplaceSetting.marketplaceName == this.marketplaces[i].name) {
            this.marketplaces[i].daysBetweenScans = marketplaceSetting.daysBetweenScans;
          }
        });
      }
    },

    async saveCatCode() {

      // Save the catCode to the database.
      //await apiParts.savePart(this.part);

      this.catCode.marketplaceSettings = [];
      for (let i = 0; i < this.marketplaces.length; i++) {
        if (this.marketplaces[i].daysBetweenScans && String(this.marketplaces[i].daysBetweenScans).trim()) {
          this.catCode.marketplaceSettings.push({
            marketplaceID: this.marketplaces[i].id,
            daysBetweenScans: Number(this.marketplaces[i].daysBetweenScans)
          });
        }
      }

      this.catCode = await apiCatCodes.saveCatCode(this.catCode);
      this.setMarketplaceSettings();
      this.getKeywords();

      // Display success message
      this.$notify({
        title: 'Cat Code Updated!',
        // text: 'Hello user!',
        type: 'success'
      });

      // Send the user to the detail page for that part.
      //this.$router.push({ name: "Part", params: { id : this.part.id } });
    },

    async navigateBackToCatCodes() {
      await this.$router.replace({ name: "CatCodes" }); // go back to the PartGroups page
    },

    async deleteCatCode() {
      // confirm deletion
      if (!confirm("Are you sure you want to delete this Cat Code?")) {
        return;
      }

      // Delete the CatCode from the database.
      await apiCatCodes.deleteCatCode(this.catCode.id);
      await this.navigateBackToCatCodes();
    },
  }
}
</script>

<style scoped>
.keywords-preview {
  display: block;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>